import { CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ClientGuard } from './components/guards/ClientGuard';
import { SitterGuard } from './components/guards/SitterGuard';
import PublicLayout from './components/layouts/PublicLayout';
import { AuthProvider } from './context/AuthContext';
import AuthCallback from './pages/Auth/AuthCallback';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import AddPetProfile from './pages/ClientPages/AddPetProfile';
import ClientBookings from './pages/ClientPages/ClientBookings/ClientBookings';
import ClientDashboard from './pages/ClientPages/ClientDashbaord/ClientDashboard';
import ClientHelpCenter from './pages/ClientPages/ClientHelpCenter/ClientHelpCenter';
import ClientMessages from './pages/ClientPages/ClientMesseges/ClientMeseeges';
import ClientProfile from './pages/ClientPages/ClientProfile/ClientProfile';
import ClientSettings from './pages/ClientPages/ClientSettings/ClientSettings';
import EditPetProfile from './pages/ClientPages/MyPets/EditPetProfile';
import MyPets from './pages/ClientPages/MyPets/MyPets';
import SitterProfile from './pages/ClientPages/SitterProfile/SitterProfile';
import BecomeASitter from './pages/LandingPages/BecomeASitter';
import DiscoverPetSitter from './pages/LandingPages/DiscoverPetSitter';
import Landing from './pages/LandingPages/Landing';
import Services from './pages/LandingPages/Services';
import BoardingSitters from './pages/SitterPages/BoardingSitters/BoardingSitters';
import SitterBookings from './pages/SitterPages/SitterBookings/SitterBookings';
import SitterCalendar from './pages/SitterPages/SitterCalendar/SitterCalendar';
import SitterDashboard from './pages/SitterPages/SitterDashboard/SitterDashboard';
import SitterEarnings from './pages/SitterPages/SitterEarnings/SitterEarnings';
import SitterHelpCenter from './pages/SitterPages/SitterHelpCenter/SitterHelpCenter';
import SitterMessages from './pages/SitterPages/SitterMessages/SitterMessages';
import SitterProfilePreview from './pages/SitterPages/SitterProfilePreview/SitterProfilePreview';
import SitterSettings from './pages/SitterPages/SitterSettings/SitterSettings';
import theme from './theme/theme';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          '.mapboxgl-ctrl-geocoder': {
            width: '100% !important',
            maxWidth: '100% !important',
            boxShadow: 'none !important',
            border: '1px solid rgba(0, 0, 0, 0.23) !important',
            borderRadius: '8px !important',
          },
          '.mapboxgl-ctrl-geocoder--input': {
            fontSize: '14px !important',
            padding: '10px 40px !important',
          },
          '.mapboxgl-ctrl-geocoder--icon-search': {
            top: '10px !important',
          },
        }}
      />
      <AuthProvider>
        <Router>
          <Routes>
            <Route
              path="/"
              element={
                <PublicLayout>
                  <Landing />
                </PublicLayout>
              }
            />
            <Route
              path="/services"
              element={
                <PublicLayout>
                  <Services />
                </PublicLayout>
              }
            />
            <Route
              path="/become-a-sitter"
              element={
                <PublicLayout>
                  <BecomeASitter />
                </PublicLayout>
              }
            />
            <Route
              path="/discover-pet-sitter"
              element={
                <PublicLayout>
                  <DiscoverPetSitter />
                </PublicLayout>
              }
            />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/auth/callback" element={<AuthCallback />} />

            {/* Client - protected */}
            <Route element={<ClientGuard />}>
              <Route path="/dashboard" element={<ClientDashboard />} />
              <Route path="/client-messages" element={<ClientMessages />} />
              <Route path="/client-bookings" element={<ClientBookings />} />
              <Route path="/my-pets" element={<MyPets />} />
              <Route path="/add-pet" element={<AddPetProfile />} />
              <Route path="/edit-pet/:id" element={<EditPetProfile />} />
              <Route path="/profile" element={<ClientProfile />} />
              <Route path="/settings" element={<ClientSettings />} />
              <Route path="/help-center" element={<ClientHelpCenter />} />
              <Route path="/sitter/:sitterId" element={<SitterProfile />} />
            </Route>

            {/* Sitter - protected */}
            <Route element={<SitterGuard />}>
              <Route path="/boarding-sitters" element={<BoardingSitters />} />

              <Route path="/sitter-dashboard" element={<SitterDashboard />} />
              <Route path="/sitter-bookings" element={<SitterBookings />} />
              <Route path="/sitter-calendar" element={<SitterCalendar />} />
              <Route path="/sitter-messages" element={<SitterMessages />} />
              <Route path="/sitter-earnings" element={<SitterEarnings />} />
              <Route path="/sitter-help-center" element={<SitterHelpCenter />} />
              <Route path="/sitter-settings" element={<SitterSettings />} />
              <Route path="/sitter-profile-preview" element={<SitterProfilePreview />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
